import { useAuth } from '@/auth/useAuth';

/**
 * The no-permission landing — §6.5.
 *
 * A user who authenticates but holds no permission sees this, naming who to
 * contact. **Never an empty dashboard**: a silent zero-permission session is
 * the hardest support call there is, because nothing on screen says what is
 * wrong or who can fix it.
 */
export default function NoAccessRoute() {
  const { me } = useAuth();

  return (
    <div className="mx-auto max-w-xl px-6 py-16 text-center">
      <h1 className="pv-page-title">Your account has no Parking Management permissions yet</h1>
      <p className="mt-3 text-pv-muted">
        You are signed in as{' '}
        <strong className="font-semibold text-pv-ink">
          {me?.displayName ?? 'an unknown user'}
        </strong>
        {me?.email ? <span> ({me.email})</span> : null}, but no role has been granted to you, so
        there is nothing here to show.
      </p>
      <div className="mt-6 pv-card px-5 py-5 text-left">
        <p className="font-semibold text-pv-ink">What to do</p>
        <ul className="mt-2 list-disc space-y-1.5 pl-5 text-pv-muted">
          <li>
            Ask a <strong className="font-semibold text-pv-ink">Parking Management admin</strong> to grant
            you a role from the Users screen — roles are assigned inside Parking Management, not in Entra.
          </li>
          <li>
            If you were told you are a commissioning engineer, ask for the local commissioning
            account instead — those expire, and yours may have lapsed.
          </li>
        </ul>
      </div>
    </div>
  );
}
